import { ServerError } from '@apollo/client/errors'
import { ErrorLink } from '@apollo/client/link/error'
import { getReduxStore } from '../../redux'

export const logoutLink = (invalidate: () => any) =>
  new ErrorLink(({ error }) => {
    if (ServerError.is(error) && error.statusCode === 401) {
      getReduxStore().dispatch(invalidate())
    }
  })
